import { useSelector } from "react-redux";
import { appdataSelector, appdata_setError } from "reducers/appdata/appdata";
import Create from "routes/app/routes/create";
import Change from "../../change/components/Change";
import Extend from "../../extend/components/Extend";
import Reactivate from "../../reactivate";

function HeaderEditable() {

    const appdata = useSelector(appdataSelector);

    console.log("header Editable", appdata.activeRequestType)
    if (appdata.activeRequestType == "NV") {
        return <Create></Create>
    }
    else if (appdata.activeRequestType == "CV") {
        return <Change></Change>
    }
    else if (appdata.activeRequestType == "EVI" || appdata.activeRequestType == "EVT"){
        return <Extend></Extend>
    }
    else if (appdata.activeRequestType == "RV") {
        return <Reactivate></Reactivate>
    }
    else {
        return <div> non implemented type {appdata.activeRequestType}</div>
    }

}
export default HeaderEditable;
